import Vue from "vue";
import Vuex from "vuex";
import mapModule from "./modules/map/index";
import { BTM_PANELS, BTM_TOOLS, MOMENTS } from "@/constants.js";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    activeMenus: {
      top: 0,
      mid: 0,
      regional: 0,
      bottom: -1 // none selected by default
    },
    activeProduct: {},
    activeDevice: {},
    bluegrowth: {
      operativity: {
        variables: [],
        products: []
      }
    },
    loading: false,
    modals: {
      showHome: false,
      showScience: false,
      showAbout: false
    },
    scToolsResults: {
      biological: {},
      marineEnergy: {}
    },
    btmDatahubActiveMoment: MOMENTS.past,
    btmDatahubActivePanel: BTM_PANELS.DATAHUB.SEARCH,
    btmBlueGrowthActivePanel: BTM_PANELS.BLUEGROWTH.SEARCH,
    btmToolsActivePanel: BTM_PANELS.TOOLS.SEARCH,
    btmToolsActiveTool: BTM_TOOLS.BIOLOGICAL_SUITABILITY,
    hindcastActivePanel: "biotool-form",
    hindcastDataResult: {
      params: {},
      data: {}
    }
  },
  getters,
  mutations,
  actions,
  modules: {
    map: mapModule
  }
});
